(function () {
  if (window.__productFinancingModalScriptLoaded) return;
  window.__productFinancingModalScriptLoaded = true;

  const LEGACY_CONTENT_MARKERS = [
    'Affirm lets eligible customers split purchases',
    'Klarna installment options may also be available',
  ];
  const DEFAULT_CLOSE_ICON_MARKUP =
    '<span class="icon icon-close" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path d="M.865 15.978a.75.75 0 001.06 1.06l7.07-7.072 7.071 7.072a.75.75 0 101.06-1.06l-7.07-7.072 7.07-7.071a.75.75 0 00-1.06-1.06L8.995 8.904 1.925 1.832A.75.75 0 10.865 2.893l7.071 7.071-7.07 7.072z" fill="currentColor"></path></svg></span>';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getTranslations(modalData) {
    return (modalData && modalData.translations) || {};
  }

  function resolveTitle(modalData) {
    const translations = getTranslations(modalData);
    const title = String((modalData && modalData.title) || '').trim();
    const defaultTitle = String(translations.defaultTitle || '').trim();
    if (!title || title.toLowerCase() === 'payment options') return defaultTitle;
    return title;
  }

  function resolveDisclaimerHtml(modalData) {
    const translations = getTranslations(modalData);
    const content = String((modalData && modalData.content) || '').trim();
    const disclaimerHtml = String(translations.disclaimerHtml || '').trim();
    if (!content) return disclaimerHtml;
    if (LEGACY_CONTENT_MARKERS.some((marker) => content.includes(marker))) return disclaimerHtml;
    return content;
  }

  function createPlanTableMarkup(modalData) {
    const planRows = Array.isArray(getTranslations(modalData).planRows) ? getTranslations(modalData).planRows : [];
    return planRows.flatMap((row) =>
      row.map((value, index) => {
        const cellClass = index === 0
          ? 'product-financing-modal__cell product-financing-modal__cell--plan'
          : 'product-financing-modal__cell product-financing-modal__cell--details';
        return `<div class="${cellClass}">${escapeHtml(value)}</div>`;
      })
    ).join('');
  }

  function createCloseIconMarkup(modalData) {
    const closeIconUrl = String((modalData && modalData.closeIconUrl) || '').trim();
    if (closeIconUrl) {
      return `<img src="${escapeHtml(closeIconUrl)}" alt="" width="24" height="24" loading="lazy" aria-hidden="true">`;
    }

    return DEFAULT_CLOSE_ICON_MARKUP;
  }

  function createModalFromData(modalData, sectionRoot) {
    if (!modalData || !modalData.id) return null;
    const translations = getTranslations(modalData);
    const modalTitle = resolveTitle(modalData);
    const disclaimerHtml = resolveDisclaimerHtml(modalData);
    const subtitle = String(translations.subtitle || '').trim();
    const closeAria = String(translations.closeAria || '').trim();

    const wrapper = document.createElement('div');
    wrapper.innerHTML = `
      <modal-dialog id="${escapeHtml(modalData.id)}" class="product-financing-modal">
        <div
          role="dialog"
          aria-label="${escapeHtml(modalTitle)}"
          aria-modal="true"
          class="product-financing-modal__content"
          tabindex="-1"
        >
          <button
            id="ModalClose-${escapeHtml(modalData.id)}"
            type="button"
            class="product-financing-modal__toggle"
            aria-label="${escapeHtml(closeAria)}"
          >
            ${createCloseIconMarkup(modalData)}
          </button>
          <div class="product-financing-modal__header">
            <div class="product-financing-modal__heading-row">
              <h2 class="product-financing-modal__title">${escapeHtml(modalTitle)}</h2>
            </div>
            <div class="product-financing-modal__subtitle">${escapeHtml(subtitle)}</div>
          </div>
          <div class="product-financing-modal__table" role="table" aria-label="${escapeHtml(modalTitle)} plans">
            ${createPlanTableMarkup(modalData)}
          </div>
          <div class="product-financing-modal__footer">
            <div class="product-financing-modal__disclaimer">${disclaimerHtml}</div>
          </div>
        </div>
      </modal-dialog>
    `;

    const modal = wrapper.firstElementChild;
    if (!modal) return null;

    (sectionRoot || document.body).appendChild(modal);
    return document.getElementById(modalData.id) || modal;
  }

  function ensureModal(modalId, modalScriptId, sectionRoot) {
    let modal = document.getElementById(modalId);
    if (modal) return modal;

    const modalDataScript = modalScriptId ? document.getElementById(modalScriptId) : null;
    if (!modalDataScript) return null;

    try {
      const modalData = JSON.parse(modalDataScript.textContent || '{}');
      if (!modalData.id || modalData.id !== modalId) return null;
      return createModalFromData(modalData, sectionRoot);
    } catch (error) {
      console.error('[product-financing-modal] failed to create modal', error);
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.product-financing-note__learn-more');
    if (!button) return;

    const modalId = button.getAttribute('data-modal-id');
    const modalScriptId = button.getAttribute('data-modal-script-id');
    const sectionRoot = button.closest('.shopify-section');
    if (!modalId) return;

    const modal = ensureModal(modalId, modalScriptId, sectionRoot);
    if (!modal) return;

    event.preventDefault();

    if (typeof modal.show === 'function') {
      modal.show(button);
      return;
    }

    modal.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  });
})();
